var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomShipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.77,21.87,50,40.11a1,1,0,0,0,1.12,1.12H70.64a2,2,0,0,1,1.62,2.87L51,79a1.85,1.85,0,0,1-3.5-.87l3.75-21.48c0-.75-.62-.5-1.37-.5H29.42c-1.37,0-2.37-2-1.62-3.25L50.28,21A1.86,1.86,0,0,1,53.77,21.87Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomShipping);
export default __webpack_public_path__ + "static/media/custom_shipping.595482591b69a8f03ef2ab9037846d8a.svg";
export { ForwardRef as ReactComponent };